export const MATCH_FLOW_LOCAL_KEY = 'match_flow';

export const MATCH_FLOWS = {
  BASIC: 'basic',
  LATEST: 'latest',
};

export const PRESENTED_MATCHED_TRIALS_STORE_KEY = 'presentedMatchedTrials';

export default {
  GET_MATCHES_REQUEST: 'GET_MATCHES_REQUEST',
  GET_MATCHES_SUCCESS: 'GET_MATCHES_SUCCESS',
  GET_MATCHES_FAILURE: 'GET_MATCHES_FAILURE',
  CLEAR_MATCHES: 'CLEAR_MATCHES',
  SET_MATCHES_IS_STALE: 'SET_MATCHES_IS_STALE',
  OPTIMIZE_SORTER_DIRECTION: {
    ASCENDING: 'ASC',
    DESCENDING: 'DESC',
  },
};
